import React, { useEffect } from 'react'
import '../Assets/Additionalcss/AccountActivation.css'
 
 
const AccountActivation =()=> {



  // function ActiveStatus(active){

   
  //   const body ={
  //    id: localStorage.getItem('hash')
  //  }
  
  //   console.log(body)
  //   let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  //    axios({
    
  //    method:"POST",
  //   url:`${BASE_URL}/User/Active`,
  //   data:body,
  //   headers: {
  //   "Content-Type" : "application/json",
  //   }
   
  //    })
  //    .then((response) =>{
  //     console.log(response.data);
  //     if(active != 0) {
  //     toast.success("Activated Successfully !", {
  //      position: "top-center",
  //      autoClose: 3200,
  //      hideProgressBar: false,
  //      closeOnClick: true,
  //      pauseOnHover: true,
  //      draggable: true,
  //      progress: undefined,
  //      className: 'toast-message'
  //      });
  //      setTimeout(() => {
         
  //        Getusers();
  //      }, 1000);
  //     }
   
  //     else if(active == 0){
  //      toast.success("InActivated Successfully !", {
  //        position: "top-center",
  //        autoClose: 3200,
  //        hideProgressBar: false,
  //        closeOnClick: true,
  //        pauseOnHover: true,
  //        draggable: true,
  //        progress: undefined,
  //        className: 'toast-message'
  //        });
  //        setTimeout(() => {
           
  //        }, 1000);
  //     }
   
  //     })
 
  
  //    }  
//      useEffect(()=>{

//      {()=>ActiveStatus(id)}


// var r  =        window.location.hash

// localStorage.setItem( 'hash',window.location.hash)


//   console.log(r.length); 
//   console.log((r).indexOf('=')); 

// console.log(r.slice((r).indexOf('=') +1,r.length));

//      })
     
    
  return(
 
    
    <div>
     <div className='circletick'  >
  {/* <input type="checkbox" /> */}
  <svg width={400} height={400}>
    <circle fill="none" stroke="#68E534" strokeWidth={20} cx={200} cy={200} r={190} className="circle" strokeLinecap="round" transform="rotate(-90 200 200) " />
    <polyline fill="none" stroke="#68E534" strokeWidth={24} points="88,214 173,284 304,138" strokeLinecap="round" strokeLinejoin="round" className="tick" />
  </svg>
      
    
  <h2 id='acc'>Account Activated</h2>
</div>
</div>

  )
}

export default AccountActivation